//GeneratorFlag:[NoChange]
import Branch from './branch';
import BranchType from './branch-type';
import City from './city';

export default {Branch, BranchType, City}
export{Branch, BranchType, City}